// extracted by mini-css-extract-plugin
module.exports = {"root":"ReservationExpired_root__15wbd","tryAgainButton":"ReservationExpired_tryAgainButton__36Slf"};